module.exports = __webpack_public_path__ + "static/img/video.df289ebe.jpg";